import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CarouselBanner from './common/CarouselBanner';
import './GardenMap.css';

function GardenMap() {
  const [selectedArea, setSelectedArea] = useState(null);

  // 图片资源

  // 静态地图区域数据
  const areas = [
    {
      id: 1,
      name: '四季药园',
      description: '展示不同季节盛开的药用植物，包括春季的牡丹、夏季的薄荷、秋季的菊花、冬季的梅花等。',
      coordinates: { x: 15, y: 20 },
      plantCount: 150,
      category: 'medicinal',
      highlights: ['白芍', '当归', '黄芪', '人参'],
      visitDuration: '30-45分钟',
      bestVisitTime: '春季4-6月，秋季9-11月'
    },
    {
      id: 2,
      name: '珍稀植物保育区',
      description: '专门保护和展示濒危珍稀植物的核心区域，包括国家一级保护植物和庐山特有种。',
      coordinates: { x: 45, y: 30 },
      plantCount: 80,
      category: 'conservation',
      highlights: ['庐山杜鹃', '华东黄杉', '银杏', '珙桐'],
      visitDuration: '45-60分钟',
      bestVisitTime: '全年开放，春季最佳'
    },
    {
      id: 3,
      name: '传统中药植物区',
      description: '收集展示传统中医药典籍中记载的经典药用植物，传承中华医药文化。',
      coordinates: { x: 70, y: 25 },
      plantCount: 200,
      category: 'traditional',
      highlights: ['金银花', '板蓝根', '连翘', '桔梗'],
      visitDuration: '40-50分钟',
      bestVisitTime: '夏季6-8月'
    },
    {
      id: 4,
      name: '现代药用植物研究展示区',
      description: '展示现代科学研究发现的新药用植物和药理成分研究成果。',
      coordinates: { x: 30, y: 60 },
      plantCount: 120,
      category: 'research',
      highlights: ['青蒿', '紫杉', '三七', '灵芝'],
      visitDuration: '35-45分钟',
      bestVisitTime: '全年开放'
    },
    {
      id: 5,
      name: '芳香植物园',
      description: '专门收集各种芳香类药用植物，通过嗅觉体验了解植物的芳香成分。',
      coordinates: { x: 60, y: 70 },
      plantCount: 90,
      category: 'aromatic',
      highlights: ['薰衣草', '迷迭香', '柠檬草', '薄荷'],
      visitDuration: '25-35分钟',
      bestVisitTime: '春夏季节'
    },
    {
      id: 6,
      name: '水生药用植物区',
      description: '展示生长在水边和湿地环境中的药用植物，体验不同生态环境的植物多样性。',
      coordinates: { x: 20, y: 80 },
      plantCount: 60,
      category: 'aquatic',
      highlights: ['荷花', '菖蒲', '半夏', '泽泻'],
      visitDuration: '20-30分钟',
      bestVisitTime: '夏季7-9月'
    }
  ];

  // 处理区域点击
  const handleAreaClick = (area) => {
    setSelectedArea(selectedArea?.id === area.id ? null : area);
  };

  // 获取区域样式类
  const getAreaCategoryClass = (category) => {
    const categoryMap = {
      medicinal: 'medicinal',
      conservation: 'conservation',
      traditional: 'traditional',
      research: 'research',
      aromatic: 'aromatic',
      aquatic: 'aquatic'
    };
    return categoryMap[category] || 'default';
  };

  return (
    <div className="garden-map-page">
      {/* Hero Section - 沿用杏林花园的Banner */}
      <CarouselBanner 
        categoryNameEn="XLHY"
        defaultTitle="花园详细地图"
        defaultSubtitle="探索杏林花园的每一个角落，发现药用植物的神奇世界"
        className="hero-section"
      />

      <div className="container">
        <div className="map-content">
          {/* 面包屑导航 */}
          <nav className="breadcrumb">
            <Link to="/">首页</Link>
            <span>/</span>
            <Link to="/garden">杏林花园</Link>
            <span>/</span>
            <span>花园地图</span>
          </nav>

          {/* 花园总览文案 */}
          <section className="garden-overview">
            <h2>花园总览</h2>
            <p>
              杏林花园占地5000平方米，拥有1000多种药用植物和珍稀植物，是中国最大的药用植物专类园之一。
              园区分为多个主题区域，包括：四季药用植物展示区、珍稀濒危植物保育区、传统中药植物区、现代药用植物研究展示区等。
              游客可以通过精心设计的步道系统，了解不同种类药用植物的特性及其在中医药中的应用。
            </p>
          </section>

              {/* 互动地图区域 */}
              <section className="interactive-map">
                <h2>互动地图</h2>
                <div className="map-container">
                  <div className="map-image-wrapper">
                    {/* 地图图片占位区域 - 您可以在这里替换为实际的花园地图图片 */}
                    <div className="map-placeholder">
                      <div className="placeholder-content">
                        <div className="placeholder-icon">🗺️</div>
                        <h3>花园地图占位区域</h3>
                        <p>请在此处放置实际的花园地图图片</p>
                        <small>建议尺寸: 1000px × 600px</small>
                      </div>
                    </div>
                    
                    {/* 地图区域标记 */}
                    {areas.map((area) => (
                      <div
                        key={area.id}
                        className={`map-marker ${getAreaCategoryClass(area.category)} ${selectedArea?.id === area.id ? 'active' : ''}`}
                        style={{
                          left: `${area.coordinates?.x || 20}%`,
                          top: `${area.coordinates?.y || 20}%`
                        }}
                        onClick={() => handleAreaClick(area)}
                        title={area.name}
                      >
                        <div className="marker-dot"></div>
                        <div className="marker-label">{area.name}</div>
                      </div>
                    ))}
                  </div>

                  {/* 区域详情面板 */}
                  {selectedArea && (
                    <div className="area-detail-panel">
                      <div className="panel-header">
                        <h3>{selectedArea.name}</h3>
                        <button 
                          className="close-btn"
                          onClick={() => setSelectedArea(null)}
                        >
                          ×
                        </button>
                      </div>
                      <div className="panel-content">
                        <p className="area-description">{selectedArea.description}</p>
                        
                        <div className="area-info">
                          <div className="info-item">
                            <span className="info-label">植物数量:</span>
                            <span className="info-value">{selectedArea.plantCount}种</span>
                          </div>
                          <div className="info-item">
                            <span className="info-label">建议参观时长:</span>
                            <span className="info-value">{selectedArea.visitDuration}</span>
                          </div>
                          <div className="info-item">
                            <span className="info-label">最佳参观时间:</span>
                            <span className="info-value">{selectedArea.bestVisitTime}</span>
                          </div>
                        </div>

                        {selectedArea.highlights && (
                          <div className="area-highlights">
                            <h4>代表植物</h4>
                            <div className="highlights-list">
                              {selectedArea.highlights.map((plant, index) => (
                                <span key={index} className="highlight-tag">{plant}</span>
                              ))}
                            </div>
                          </div>
                        )}

                        <div className="panel-actions">
                          <Link 
                            to={`/garden/area/${selectedArea.id}`}
                            className="detail-btn"
                          >
                            查看详情
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </section>
        </div>
      </div>
    </div>
  );
}

export default GardenMap;
